import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import fetchImporterLocations from '../../actions/importers/fetchImporterLocations'
import awaitAccessToken from '../../modules/awaitAccessToken'

const onFetchImporterLocations = function* onFetchImporterLocations() {
  yield takeLatest(actionTypes.IMPORTERS.FETCH_LOCATIONS, function* onFetchImporterLocationsSaga(action) {
    const accessToken = yield call(awaitAccessToken)

    let response
    const { payload } = action

    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.importers}/${payload}/locations`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
          'X-Infowijs-Client': 'nl.infowijs.admin',
        },
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reFetchImporterLocations() {
          yield put(fetchImporterLocations(payload))
        })
      }

      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    acceptAction(action, response.data.data || [])
  })
}

export default onFetchImporterLocations
